import React, { useEffect, useState } from "react";
import { useNotificationContext } from "../../../common/NotificationContext";
import { useLoading } from "../../../common/LoadingContext";
import {
  functListingSearchService,
  departmentListingService,
  functionListingService,
} from "../../../services/UserOnboardingService";
import FunctionList from "./FunctionList";
import useGlobalState from "../../../Context";

const Function = () => {
  const [totalElements, setTotalElements] = useState(0);
  // const [tableLoader, setTableLoader] = useState(false);
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [departmentList, setDepartmentList] = useState([]);
  const [functionList, setFunctionList] = useState([]);
  const [noRecord, setNoRecord] = useState(false);
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserType = auth.ldapParam.userType;

  useEffect(() => {
    fetchFunctionList("name", false);
  }, []);

  const fetchFunctionList = async (sortBy, isAsc, id,searchValue,paginationData) => {
    
    try {
      setLoading(true);
      const obj = {
        pageNumber: paginationData?.page ?? 0,
        pageSize:  paginationData?.pageSize ??  10,
        filterSearch: searchValue? searchValue : null,
        active: loginUserType === "Main Admin" ? 2 : 0,
         sortDirection: isAsc ? "DESC" : "ASC",
        sortBy: sortBy,
      };
    
      const response = await functionListingService(obj);
      if (response.statusCode === 6) {
        if (response.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setFunctionList(response.data.content);
        setTotalElements(response.data.totalElements);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
      showNotification("Error", "Faild to fetch Function list", "error");
    } finally {
      setLoading(false);
    }
  };

  const onSearch = async (values, searchValue) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortDirection: "ASC",
        sortBy: "name",
        active: loginUserType === "Main Admin" ? 2 : 0,
      };
      //console.log('requestBody search',requestBody)
      const response = await functListingSearchService(
        requestBody,
        searchValue
      );
      if (response.statusCode === 6) {
        if (response.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setFunctionList(response.data.content);
        setTotalElements(response.data.totalElements);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch  details");
    } finally {
      setLoading(false);
    }
  };

  const handleTableChanges = async (
    paginationValues,
    isUpdate,
    id,
    sortValue,
    orderBy,
    searchValue
  ) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: paginationValues?.pageNumber ?? 0,
        pageSize: paginationValues?.pageSize ?? 10,
        active: loginUserType === "Main Admin" ? 2 : 0,
        filterSearch: searchValue ? searchValue.trim() : null,
       // categoryId:  null,
        sortDirection: sortValue === null ? "DESC" : sortValue,
        sortBy: orderBy,
      };
     // console.log('requestBody row change requestBody',requestBody)
      // setTableLoader(true);
      const response = await functionListingService(requestBody);

      if (response.statusCode === 6) {
        if (isUpdate) {
          setFunctionList([
            ...functionList,
            ...response.data.content,
          ]);
        } else {
          setFunctionList(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
      // setTableLoader(false);
    }
  };

  const fetchDepartmentList = async () => {
    try {
      const requestBody = {
        pageSize: 200,
        pageNumber: 0,
        filterSearch: null,
        active: 0,
        sortDirection: "DESC",
        sortBy: "name",
      };
      const response = await departmentListingService(requestBody);
     // console.log('departmentList',response)
      if (response.statusCode === 6) {
        setDepartmentList(response.data);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  return (
    <FunctionList
      totalElements={totalElements}
      setFunctionList={setFunctionList}
      onSearch={onSearch}
      handleTableChanges={handleTableChanges}
      setLoading={setLoading}
      showNotification={showNotification}
      fetchDepartmentList={fetchDepartmentList}
      departmentList={departmentList}
      fetchFunctionList={fetchFunctionList}
      functionList={functionList}
      noRecord={noRecord}
    />
  );
};

export default Function;
